// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme from "../styles/Theme.bs.js";
import * as NovaEmotion from "@cosmonexus/nova-emotion";

function css(prim) {
  return NovaEmotion.css(prim);
}

function rawCss(prim) {
  return NovaEmotion.css(prim);
}

function keyframes(prim) {
  return NovaEmotion.keyframes(prim);
}

function cx(prim) {
  return NovaEmotion.cx(prim);
}

function injectGlobal(prim) {
  NovaEmotion.injectGlobal(prim);
}

let Css = {
  css: css,
  rawCss: rawCss,
  keyframes: keyframes,
  cx: cx,
  injectGlobal: injectGlobal
};

function sm(styles) {
  return NovaEmotion.css(Theme.Theme.Breakpoints.media.sm + ` { ` + styles + ` }`);
}

function md(styles) {
  return NovaEmotion.css(Theme.Theme.Breakpoints.media.md + ` { ` + styles + ` }`);
}

function lg(styles) {
  return NovaEmotion.css(Theme.Theme.Breakpoints.media.lg + ` { ` + styles + ` }`);
}

function xl(styles) {
  return NovaEmotion.css(Theme.Theme.Breakpoints.media.xl + ` { ` + styles + ` }`);
}

function xl2(styles) {
  return NovaEmotion.css(Theme.Theme.Breakpoints.media["2xl"] + ` { ` + styles + ` }`);
}

let Responsive = {
  sm: sm,
  md: md,
  lg: lg,
  xl: xl,
  xl2: xl2
};

let primary = Theme.Theme.Colors.brand.primary;

let primaryLight = Theme.Theme.Colors.brand["primary-light"];

let primaryDark = Theme.Theme.Colors.brand["primary-dark"];

let secondary = Theme.Theme.Colors.brand.secondary;

let secondaryLight = Theme.Theme.Colors.brand["secondary-light"];

let secondaryDark = Theme.Theme.Colors.brand["secondary-dark"];

let success = Theme.Theme.Colors.semantic.success;

let successDark = Theme.Theme.Colors.semantic["success-dark"];

let warning = Theme.Theme.Colors.semantic.warning;

let error = Theme.Theme.Colors.semantic.error;

let errorDark = Theme.Theme.Colors.semantic["error-dark"];

let info = Theme.Theme.Colors.semantic.info;

let textPrimary = Theme.Theme.Colors.text.primary;

let textSecondary = Theme.Theme.Colors.text.secondary;

let textDisabled = Theme.Theme.Colors.text.disabled;

let textInverse = Theme.Theme.Colors.text.inverse;

let bgPrimary = Theme.Theme.Colors.background.primary;

let bgSecondary = Theme.Theme.Colors.background.secondary;

let bgElevated = Theme.Theme.Colors.background.elevated;

let bgOverlay = Theme.Theme.Colors.background.overlay;

let border = Theme.Theme.Colors.border.default;

let borderHover = Theme.Theme.Colors.border.hover;

let placeholder = Theme.Theme.Colors.placeholder;

let Color = {
  primary: primary,
  primaryLight: primaryLight,
  primaryDark: primaryDark,
  secondary: secondary,
  secondaryLight: secondaryLight,
  secondaryDark: secondaryDark,
  success: success,
  successDark: successDark,
  warning: warning,
  error: error,
  errorDark: errorDark,
  info: info,
  textPrimary: textPrimary,
  textSecondary: textSecondary,
  textDisabled: textDisabled,
  textInverse: textInverse,
  bgPrimary: bgPrimary,
  bgSecondary: bgSecondary,
  bgElevated: bgElevated,
  bgOverlay: bgOverlay,
  border: border,
  borderHover: borderHover,
  placeholder: placeholder
};

let xs = NovaEmotion.css({
  fontSize: Theme.Theme.Typography.fontSize.xs
});

let sm$1 = NovaEmotion.css({
  fontSize: Theme.Theme.Typography.fontSize.sm
});

let base = NovaEmotion.css({
  fontSize: Theme.Theme.Typography.fontSize.base
});

let lg$1 = NovaEmotion.css({
  fontSize: Theme.Theme.Typography.fontSize.lg
});

let xl$1 = NovaEmotion.css({
  fontSize: Theme.Theme.Typography.fontSize.xl
});

let xl2$1 = NovaEmotion.css({
  fontSize: Theme.Theme.Typography.fontSize["2xl"]
});

let xl3 = NovaEmotion.css({
  fontSize: Theme.Theme.Typography.fontSize["3xl"]
});

let thin = NovaEmotion.css({
  fontWeight: Theme.Theme.Typography.fontWeight.thin
});

let light = NovaEmotion.css({
  fontWeight: Theme.Theme.Typography.fontWeight.light
});

let normal = NovaEmotion.css({
  fontWeight: Theme.Theme.Typography.fontWeight.normal
});

let medium = NovaEmotion.css({
  fontWeight: Theme.Theme.Typography.fontWeight.medium
});

let semibold = NovaEmotion.css({
  fontWeight: Theme.Theme.Typography.fontWeight.semibold
});

let bold = NovaEmotion.css({
  fontWeight: Theme.Theme.Typography.fontWeight.bold
});

function leading(tightOpt, looseOpt, param) {
  let tight = tightOpt !== undefined ? tightOpt : false;
  let loose = looseOpt !== undefined ? looseOpt : false;
  if (tight) {
    return NovaEmotion.css({
      lineHeight: Theme.Theme.Typography.lineHeight.tight
    });
  } else if (loose) {
    return NovaEmotion.css({
      lineHeight: Theme.Theme.Typography.lineHeight.loose
    });
  } else {
    return NovaEmotion.css({
      lineHeight: Theme.Theme.Typography.lineHeight.normal
    });
  }
}

let fontSans = NovaEmotion.css({
  fontFamily: Theme.Theme.Typography.fontFamily.sans
});

let fontMono = NovaEmotion.css({
  fontFamily: Theme.Theme.Typography.fontFamily.mono
});

let Text = {
  xs: xs,
  sm: sm$1,
  base: base,
  lg: lg$1,
  xl: xl$1,
  xl2: xl2$1,
  xl3: xl3,
  thin: thin,
  light: light,
  normal: normal,
  medium: medium,
  semibold: semibold,
  bold: bold,
  leading: leading,
  fontSans: fontSans,
  fontMono: fontMono
};

function getSpacing(size) {
  switch (size) {
    case "0" :
      return "0";
    case "0.5" :
      return "0.125rem";
    case "1" :
      return NovaEmotion.theme.space[1];
    case "1.5" :
      return "0.375rem";
    case "10" :
      return NovaEmotion.theme.space[10];
    case "12" :
      return "3rem";
    case "14" :
      return "3.5rem";
    case "16" :
      return "4rem";
    case "2" :
      return NovaEmotion.theme.space[2];
    case "2.5" :
      return "0.625rem";
    case "20" :
      return "5rem";
    case "24" :
      return "6rem";
    case "3" :
      return NovaEmotion.theme.space[3];
    case "3.5" :
      return "0.875rem";
    case "32" :
      return "8rem";
    case "4" :
      return NovaEmotion.theme.space[4];
    case "40" :
      return "10rem";
    case "48" :
      return "12rem";
    case "5" :
      return NovaEmotion.theme.space[5];
    case "56" :
      return "14rem";
    case "6" :
      return NovaEmotion.theme.space[6];
    case "64" :
      return "16rem";
    case "7" :
      return "1.75rem";
    case "8" :
      return NovaEmotion.theme.space[8];
    case "9" :
      return "2.25rem";
    case "px" :
      return "1px";
    default:
      return "1rem";
  }
}

function p(size) {
  return NovaEmotion.css({
    padding: getSpacing(size)
  });
}

function px(size) {
  return NovaEmotion.css({
    paddingLeft: getSpacing(size),
    paddingRight: getSpacing(size)
  });
}

function py(size) {
  return NovaEmotion.css({
    paddingTop: getSpacing(size),
    paddingBottom: getSpacing(size)
  });
}

function pt(size) {
  return NovaEmotion.css({
    paddingTop: getSpacing(size)
  });
}

function pr(size) {
  return NovaEmotion.css({
    paddingRight: getSpacing(size)
  });
}

function pb(size) {
  return NovaEmotion.css({
    paddingBottom: getSpacing(size)
  });
}

function pl(size) {
  return NovaEmotion.css({
    paddingLeft: getSpacing(size)
  });
}

function m(size) {
  return NovaEmotion.css({
    margin: getSpacing(size)
  });
}

function mx(size) {
  return NovaEmotion.css({
    marginLeft: getSpacing(size),
    marginRight: getSpacing(size)
  });
}

function my(size) {
  return NovaEmotion.css({
    marginTop: getSpacing(size),
    marginBottom: getSpacing(size)
  });
}

function mt(size) {
  return NovaEmotion.css({
    marginTop: getSpacing(size)
  });
}

function mr(size) {
  return NovaEmotion.css({
    marginRight: getSpacing(size)
  });
}

function mb(size) {
  return NovaEmotion.css({
    marginBottom: getSpacing(size)
  });
}

function ml(size) {
  return NovaEmotion.css({
    marginLeft: getSpacing(size)
  });
}

let Space = {
  getSpacing: getSpacing,
  p: p,
  px: px,
  py: py,
  pt: pt,
  pr: pr,
  pb: pb,
  pl: pl,
  m: m,
  mx: mx,
  my: my,
  mt: mt,
  mr: mr,
  mb: mb,
  ml: ml
};

let flexCenter = NovaEmotion.css({
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
});

let flexBetween = NovaEmotion.css({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between"
});

let flexCol = NovaEmotion.css({
  display: "flex",
  flexDirection: "column"
});

function grid(cols, gap, param) {
  if (gap !== undefined) {
    if (cols !== undefined) {
      return NovaEmotion.css({
        display: "grid",
        gap: getSpacing(gap),
        gridTemplateColumns: `repeat(` + cols.toString() + `, 1fr)`
      });
    } else {
      return NovaEmotion.css({
        display: "grid",
        gap: getSpacing(gap)
      });
    }
  } else if (cols !== undefined) {
    return NovaEmotion.css({
      display: "grid",
      gridTemplateColumns: `repeat(` + cols.toString() + `, 1fr)`
    });
  } else {
    return NovaEmotion.css({
      display: "grid"
    });
  }
}

function container(maxWidth, param) {
  let maxW = maxWidth !== undefined ? maxWidth : "1280px";
  return NovaEmotion.css({
    margin: "0 auto",
    padding: `0 ` + getSpacing("4"),
    maxWidth: maxW
  });
}

let Layout = {
  flexCenter: flexCenter,
  flexBetween: flexBetween,
  flexCol: flexCol,
  grid: grid,
  container: container
};

function getRadius(size) {
  switch (size) {
    case "2xl" :
      return "1rem";
    case "3xl" :
      return "1.5rem";
    case "full" :
      return NovaEmotion.theme.radius.full;
    case "lg" :
      return NovaEmotion.theme.radius.lg;
    case "md" :
      return NovaEmotion.theme.radius.md;
    case "none" :
      return "0";
    case "sm" :
      return NovaEmotion.theme.radius.sm;
    case "xl" :
      return "0.75rem";
    default:
      return "0.25rem";
  }
}

function getBorderWidth(width) {
  switch (width) {
    case "0" :
      return "0";
    case "2" :
      return "2px";
    case "4" :
      return "4px";
    case "8" :
      return "8px";
    default:
      return "1px";
  }
}

function rounded(sizeOpt, param) {
  let size = sizeOpt !== undefined ? sizeOpt : "base";
  return NovaEmotion.css({
    borderRadius: getRadius(size)
  });
}

function border$1(widthOpt, colorOpt, param) {
  let width = widthOpt !== undefined ? widthOpt : "1";
  let color = colorOpt !== undefined ? colorOpt : Theme.Theme.Colors.border.default;
  return NovaEmotion.css({
    border: getBorderWidth(width) + ` solid ` + color
  });
}

let Border = {
  getRadius: getRadius,
  getBorderWidth: getBorderWidth,
  rounded: rounded,
  border: border$1
};

function getShadow(level) {
  switch (level) {
    case "2xl" :
      return "0 25px 50px -12px rgb(0 0 0 / 0.25)";
    case "base" :
      return "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)";
    case "lg" :
      return "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)";
    case "md" :
      return NovaEmotion.theme.shadow.md;
    case "sm" :
      return "0 1px 2px 0 rgb(0 0 0 / 0.05)";
    case "xl" :
      return "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)";
    default:
      return "none";
  }
}

function getFocusShadow(color) {
  switch (color) {
    case "error" :
      return "0 0 0 3px rgba(239, 68, 68, 0.25)";
    case "success" :
      return "0 0 0 3px rgba(34, 197, 94, 0.25)";
    case "warning" :
      return "0 0 0 3px rgba(245, 158, 11, 0.25)";
    default:
      return "0 0 0 3px rgba(200, 164, 92, 0.25)";
  }
}

let sm$2 = NovaEmotion.css({
  boxShadow: getShadow("sm")
});

let base$1 = NovaEmotion.css({
  boxShadow: getShadow("base")
});

let md$1 = NovaEmotion.css({
  boxShadow: getShadow("md")
});

let lg$2 = NovaEmotion.css({
  boxShadow: getShadow("lg")
});

let xl$2 = NovaEmotion.css({
  boxShadow: getShadow("xl")
});

let xl2$2 = NovaEmotion.css({
  boxShadow: getShadow("2xl")
});

function focus(colorOpt, param) {
  let color = colorOpt !== undefined ? colorOpt : "primary";
  return NovaEmotion.css({
    boxShadow: getFocusShadow(color)
  });
}

let Shadow = {
  getShadow: getShadow,
  getFocusShadow: getFocusShadow,
  sm: sm$2,
  base: base$1,
  md: md$1,
  lg: lg$2,
  xl: xl$2,
  xl2: xl2$2,
  focus: focus
};

function getDuration(duration) {
  switch (duration) {
    case "fast" :
      return NovaEmotion.theme.transition.fast;
    case "fastest" :
      return "150ms";
    case "normal" :
      return NovaEmotion.theme.transition.normal;
    case "slow" :
      return NovaEmotion.theme.transition.slow;
    case "slowest" :
      return "800ms";
    default:
      return "300ms";
  }
}

function getEasing(easing) {
  switch (easing) {
    case "bounce" :
      return "cubic-bezier(0.68, -0.55, 0.265, 1.55)";
    case "ease" :
      return "ease";
    case "ease-in" :
      return "ease-in";
    case "ease-in-out" :
      return NovaEmotion.theme.easing.inOut;
    case "ease-out" :
      return NovaEmotion.theme.easing.out;
    case "linear" :
      return "linear";
    default:
      return "ease-out";
  }
}

function transition(durationOpt, propertyOpt, easingOpt, param) {
  let duration = durationOpt !== undefined ? durationOpt : "normal";
  let property = propertyOpt !== undefined ? propertyOpt : "all";
  let easing = easingOpt !== undefined ? easingOpt : "ease-out";
  return NovaEmotion.css({
    transition: property + ` ` + getDuration(duration) + ` ` + getEasing(easing)
  });
}

let fadeIn = NovaEmotion.css({
  animation: "fadeIn 300ms ease-out"
});

let slideUp = NovaEmotion.css({
  animation: "slideUp 300ms ease-out"
});

let Animate = {
  getDuration: getDuration,
  getEasing: getEasing,
  transition: transition,
  fadeIn: fadeIn,
  slideUp: slideUp
};

let Utils = {
  Responsive: Responsive,
  Color: Color,
  Text: Text,
  Space: Space,
  Layout: Layout,
  Border: Border,
  Shadow: Shadow,
  Animate: Animate
};

let fadeIn$1 = NovaEmotion.keyframes({
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
});

let fadeOut = NovaEmotion.keyframes({
  from: {
    opacity: 1
  },
  to: {
    opacity: 0
  }
});

let slideInLeft = NovaEmotion.keyframes({
  from: {
    transform: "translateX(-100%)"
  },
  to: {
    transform: "translateX(0)"
  }
});

let slideInRight = NovaEmotion.keyframes({
  from: {
    transform: "translateX(100%)"
  },
  to: {
    transform: "translateX(0)"
  }
});

let slideUp$1 = NovaEmotion.keyframes({
  from: {
    transform: "translateY(100%)"
  },
  to: {
    transform: "translateY(0)"
  }
});

let spin = NovaEmotion.keyframes({
  from: {
    transform: "rotate(0deg)"
  },
  to: {
    transform: "rotate(360deg)"
  }
});

let pulse = NovaEmotion.keyframes({
  "0%": {
    transform: "scale(1)"
  },
  "50%": {
    transform: "scale(1.05)"
  },
  "100%": {
    transform: "scale(1)"
  }
});

let Animations = {
  fadeIn: fadeIn$1,
  fadeOut: fadeOut,
  slideInLeft: slideInLeft,
  slideInRight: slideInRight,
  slideUp: slideUp$1,
  spin: spin,
  pulse: pulse
};

export {
  Css,
  Utils,
  Animations,
}
/* primary Not a pure module */
